/**
 * fhirSubscriptionsApi.js — Frontend adapter for the FHIR R5 Topic-Based
 * Subscription Registration API.
 *
 * Backend contract (same-origin, proxied server-to-server to the upstream
 * FHIR R5 server via `fhir_client.create_subscription / …`):
 *   GET    /api/fhir/subscriptions/status
 *   POST   /api/fhir/subscriptions/registrations
 *   GET    /api/fhir/subscriptions/registrations?status=&topic=&limit=
 *   GET    /api/fhir/subscriptions/registrations/:id
 *   PUT    /api/fhir/subscriptions/registrations/:id
 *   DELETE /api/fhir/subscriptions/registrations/:id?sync_to_remote=
 *   POST   /api/fhir/subscriptions/registrations/:id/activate
 *   POST   /api/fhir/subscriptions/registrations/:id/deactivate
 *   POST   /api/fhir/subscriptions/registrations/:id/retry
 *   GET    /api/fhir/subscriptions/events?limit=
 *   GET    /api/fhir/subscriptions/queue?limit=
 *
 * Browser always stays same-origin (enforced by httpClient's
 * SAME_ORIGIN_ONLY_PATHS lock for `/api/fhir/subscriptions/*`).
 */
import { get, post, put, del, requireParam } from './httpClient';

const BASE = '/api/fhir/subscriptions';

/* ═══ Read ═══ */

export const getStatus = () => get(`${BASE}/status`);

export const listRegistrations = ({ status, topic, limit } = {}) => {
  const params = {};
  if (status) params.status = status;
  if (topic) params.topic = topic;
  if (limit) params.limit = limit;
  return get(`${BASE}/registrations`, params);
};

export const getRegistration = (id) => {
  requireParam('id', id);
  return get(`${BASE}/registrations/${id}`);
};

export const listEvents = (limit = 50) => get(`${BASE}/events`, { limit });
export const listQueue  = (limit = 50) => get(`${BASE}/queue`,  { limit });

/* ═══ Write ═══ */

export const createRegistration = (payload) => {
  requireParam('payload', payload);
  requireParam('name', payload.name);
  requireParam('topic', payload.topic);
  requireParam('endpoint', payload.endpoint);
  return post(`${BASE}/registrations`, payload);
};

export const updateRegistration = (id, patch) => {
  requireParam('id', id);
  return put(`${BASE}/registrations/${id}`, patch);
};

export const deleteRegistration = (id, { syncToRemote = true } = {}) => {
  requireParam('id', id);
  const qs = syncToRemote ? '' : '?sync_to_remote=false';
  return del(`${BASE}/registrations/${id}${qs}`);
};

export const activateRegistration   = (id) => { requireParam('id', id); return post(`${BASE}/registrations/${id}/activate`);   };
export const deactivateRegistration = (id) => { requireParam('id', id); return post(`${BASE}/registrations/${id}/deactivate`); };
export const retryRegistration      = (id) => { requireParam('id', id); return post(`${BASE}/registrations/${id}/retry`);      };
